// Ensure correct import path
import { Text } from '@growtherapy/sprout-ui';

import { IntakeFormSection } from './IntakeFormSection';
// Ensure correct import path
import { SafetyPlanFormSection } from './SafetyPlanFormSection';
import { FormType, GroupedFormData } from './types';

type FormResponseProps = {
  selectedForm: GroupedFormData;
};
export function FormResponse({ selectedForm }: FormResponseProps) {
  const renderFormContent = () => {
    const allQuestions = Object.values(selectedForm.formQuestionsWithAnswers).flat();

    switch (selectedForm.formType) {
      case FormType.Intake:
        return <IntakeFormSection selectedForm={selectedForm} />;
      case FormType.NoteToProvider:
        return (
          <div
            className='relative py-4 text-start fs-exclude rounded-none border-b border-neutral-600'
            data-testid='client-information.forms.note-to-provider'
            data-dd-privacy='mask'
          >
            <Text className='mb-1 font-medium rebrand:text-text-inverse'>
              Is there anything else you would like to share with your provider?
            </Text>
            <Text className='rebrand:text-text-inverse'>{(allQuestions[0]?.answer as string) ?? ''}</Text>
          </div>
        );
      case FormType.Safetyplan:
        return <SafetyPlanFormSection selectedForm={selectedForm} />;
      case FormType.Gad7:
      case FormType.Phq9:
        return (
          <div
            data-testid='client-information.forms.questionnaire'
            className='relative text-start fs-exclude rounded-none'
            data-dd-privacy='mask'
          >
            {allQuestions.map((element, i) => (
              <div className='relative py-4 text-start border-b border-neutral-600' key={i}>
                <Text className='mb-1 font-medium rebrand:text-text-inverse'>
                  {i + 1}. {element.question}
                </Text>
                <Text className='rebrand:text-text-inverse'>{element.answer as string}</Text>
              </div>
            ))}
          </div>
        );
    }
  };

  return <>{renderFormContent()}</>;
}
